export default {"src":"/_next/static/media/img_main_section3_10.5cb9f73e.svg","height":247,"width":320,"blurWidth":0,"blurHeight":0};